(function () {
  function initScrollReveal() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('.scroll-reveal'));
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (node) { node.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    nodes.forEach(function (node) { observer.observe(node); });
  }

  function initCollectionControls() {
    document.querySelectorAll('.product-sort-form select').forEach(function (select) {
      if (select.dataset.ruahSortReady === 'true') return;
      select.dataset.ruahSortReady = 'true';
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });

    document.querySelectorAll('[data-filter-close]').forEach(function (button) {
      if (button.dataset.ruahFilterReady === 'true') return;
      button.dataset.ruahFilterReady = 'true';
      button.addEventListener('click', function () {
        var drawer = button.closest('.product-filter-drawer');
        if (drawer) drawer.removeAttribute('open');
      });
    });
  }

  function initRuah() {
    initScrollReveal();
    initCollectionControls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRuah);
  } else {
    initRuah();
  }

  document.addEventListener('shopify:section:load', initRuah);
})();
